import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type DataSecurityUptimeMonitorPeriod = {
	changePercentage: number;
	integratedAppId: number;
	downtimeDays: Array<number>;
	uptimePercentage: number;
	uptimeInterval: number;
};

export type DataSecurityUptimeMonitorPeriodRequest = {
	applicationId?: number;
};

export type DataSecurityUptimeMonitorPeriodResponse = DataSecurityUptimeMonitorPeriod[];

export const getDataSecurityUptimeMonitorsDashboard = createGetEndpoint<
	DataSecurityUptimeMonitorPeriodRequest,
	DataSecurityUptimeMonitorPeriodResponse
>(({ applicationId }) => `/api/v3/data-security/monitors/uptime-monitors?${getQueryString({ applicationId })}`);
